import { useCallback, useEffect, useState } from "react";
import useSmartRef from "./useSmartRef";
import { useWebSocketContext } from "../providers/WebSocketContextProvider";
import { useOperatorContext } from "../comps/login/OperatorContextProvider";


export default function useTopicHandler(topicName) {
  const {operator}                       = useOperatorContext();
  const {wsSubscribe}                    = useWebSocketContext();
  const {get:getMySubsList}              = useSmartRef({});
  const [topicData, setTopicData]        = useState(null);
  const [topicPath, setTopicPath]        = useState(null);

  // ---[  Subscribe If Absent  ]---
  //
  const subscribeIfAbsent = useCallback((channelName, handler) => {
    if ( !Boolean(getMySubsList()[channelName]) ) {
      const sId = wsSubscribe(channelName, handler, true);
      if (sId) {
        getMySubsList()[channelName] = sId;
        //console.log('[useTopicHandler subscribeIfAbsent] My Page List [channel: %s] [sId: %s]', channelName, sId);
      }
      else {
        console.error('[useTopicHandler subscribeIfAbsent] No Result from wsSubscribe [sId: %s]', sId);
      }
    }
  }, [getMySubsList, wsSubscribe]);


  //
  // ---[  onTopicData  ]---
  //
  const onTopicData = useCallback((msg) => {
    msg.ack();
    if (msg.body) {
      const data = JSON.parse(msg.body);
      //console.log('[useTopicHandler onTopicData] [topicName: %s] [data: %s]', topicName, JSON.stringify(data, null, 2));
      setTopicData( prev => ({...prev, ...data}));
    }
  }, []);


  // TODO: Consider removing cleanup totally, and Maybe on Logout only, cleanup all. but we're doing that already I think with the disconnect...
  // // ------ Cleanup Topic ------
  // //
  // const cleanupTopic = useCallback((from) => {
  //   console.log('[useTopicHandler cleanupTopic] From %s', from);
    
  //   Object.keys(getMySubsList()).forEach(channelName => {
  //     const subId = getMySubsList()[channelName];
  //     wsUnsubscribe(subId);
  //     delete getMySubsList()[channelName];
  //     console.log('[useTopicHandler cleanupTopic] Removed from MySubsList [channel: %s - %s]', channelName, subId);
  //   });
  // }, [getMySubsList, wsUnsubscribe]);


  // ------   Effect topicPath   ------
  //
  useEffect(()=>{
    if (operator?.selectedTeamId) {
      setTopicPath(`/topic/team/${operator.selectedTeamId}/${topicName}`);
    }

    return ()=> {
      // cleanupTopic('Effect operator, topicName');
    }
  }, [operator, topicName]);

  useEffect(()=>{
    if (topicPath) {
      subscribeIfAbsent(topicPath, onTopicData);
    }
  }, [topicPath, subscribeIfAbsent, onTopicData]);

  return {
    topicData
  }
}
